<template lang="pug">
  #membership.admin.theme-1
    section.material-half-bg
      .cover
    section.membership-form
      .modal(tabindex="-1" style="position: relative; display: block;", v-if="state.matches('fetch_config')")
        .modal-dialog.modal-sm.modal-dialog-centered
          .modal-content
            .modal-body
              | Initializing. . .
              i.m-0.fa.fa-spin.fa-circle-notch.float-right
      .modal(tabindex="-1" style="position: relative; display: block;", v-else)
        .modal-dialog.modal-xl
          .modal-content
            .modal-header.d-flex.justify-content-center
              div
                span.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 1, 'badge-primary': state.matches('step_1')}") Confirmatory
                span.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 2, 'badge-primary': state.matches('step_2')}") Personal Details
                span.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 3, 'badge-primary': state.matches('step_3')}") Emergency Contact
                span.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 4, 'badge-primary': state.matches('step_4')}") Products and Services
                span.badge.badge-pill.border(:class="{'badge-secondary': state.context.currentStep > 5, 'badge-primary': state.matches('step_5')}") Terms and consent
              //- .btn-group.btn-sm
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 1, 'btn-primary': state.matches('step_1')}") Step 1
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 2, 'btn-primary': state.matches('step_2')}") Step 2
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 3, 'btn-primary': state.matches('step_3')}") Step 3
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 4, 'btn-primary': state.matches('step_4')}") Step 4
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 5, 'btn-primary': state.matches('step_5')}") Step 5
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 6, 'btn-primary': state.matches('step_6')}") Step 6
                button.btn-sm.btn(type="button", :class="{'btn-secondary': state.context.currentStep > 7, 'btn-primary': state.matches('step_7')}") Step 7
            .modal-body
              .row
                .col-12(v-show="state.matches('step_1')")
                  step_1(@next="send('NEXT')")
                .col-12(v-show="state.matches('step_2')")
                  step_2(@prev="send('PREV')", @next="send('NEXT')")
                .col-12(v-show="state.matches('step_3')")
                  step_3(@prev="send('PREV')", @next="send('NEXT')")
                .col-12(v-show="state.matches('step_4')")
                  step_4(@prev="send('PREV')", @next="send('NEXT')")
                .col-12(v-show="state.matches('step_5')")
                  step_5(@prev="send('PREV')")
                .col-12(v-show="state.matches('step_6')")
                  step_6
                .col-12(v-show="state.matches('step_7')")
                  step_7
            .modal-footer.d-flex.justify-content-between
              button.btn.btn-secondary(type="button", :disabled="state.matches('step_1')" @click.prevent="send('PREV')") Previous
              button.btn.btn-primary(type="button", :disabled="state.matches('step_7')" @click.prevent="send('NEXT')") Next
</template>

<script>
  import { ref, reactive, onMounted } from '@vue/composition-api'
  import { createMachine } from 'xstate'
  import { useMachine } from 'xstate-vue2'
  const Machine = createMachine(require('./index.state').default)

  export default {

    name: 'membership',
    components: {
      'step_1': require('./components/step_1.vue').default,
      'step_2': require('./components/step_2.vue').default,
      'step_3': require('./components/step_3.vue').default,
      'step_4': require('./components/step_4.vue').default,
      'step_5': require('./components/step_5.vue').default,
      'step_6': require('./components/step_6.vue').default,
      'step_7': require('./components/step_7.vue').default,
    },

    setup (props, {emit, root}) {
      const config = ref({})
      const { $swal, $store } = root
      const { send, state } = useMachine(Machine, {
        guards: {},
        actions: {
          /**
           * [validationError description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validationError(ctx, event) {
            $swal({
              icon: 'error',
              title: 'Validation Error!',
              text: 'Please complete the form fields.'
            })
          }
        },
        services: {
          /**
           * [validateStep1 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep1(ctx, event) {
            return Promise.resolve(true)
          },
          /**
           * [validateStep2 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep2(ctx, event) {
            return Promise.resolve(true)
          },
          /**
           * [validateStep3 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep3(ctx, event) {
            return Promise.resolve(true)
          },
          /**
           * [validateStep4 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep4(ctx, event) {
            return Promise.resolve(true)
          },
          /**
           * [validateStep5 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep5(ctx, event) {
            return Promise.resolve(true)
          },
          /**
           * [validateStep6 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep6(ctx, event) {
            return Promise.resolve(true)
          },
          /**
           * [validateStep7 description]
           * @param  {[type]} ctx   [description]
           * @param  {[type]} event [description]
           * @return {[type]}       [description]
           */
          validateStep7(ctx, event) {
            return Promise.resolve(true)
          }
        }
      })
      onMounted(() => {
        // $swal({
        //   text: 'Please wait. . .',
        //   allowOutsideClick: false,
        //   allowEscapeKey: false
        // })
        // $swal.showLoading()
        $store.dispatch('membership/get_config')
          .then(response => {
            // console.log(config)
            config.value = response
          }).finally(() => {
            send('STEP_1')
          })
      })
      return {
        config,
        send, state
      }
    }
  }
</script>

<style lang="css" scoped>
</style>